import React from 'react';
import PropTypes from 'prop-types';

// COMPONENTS
import AppsSection from './help/AppsSection';
import ChannelsSection from './help/ChannelsSection';
import ShowMovieSection from './help/ShowMovieSection';
import ContentCrewSection from './help/ContentCrewSection';

const SectionManager = props => {
  const { data } = props;
  let content = null;

  switch (data.type) {
    case 'app':
      content = <AppsSection {...props} />;
      break;
    case 'channel':
      content = <ChannelsSection {...props} />;
      break;
    case 'movie':
    case 'show':
      content = <ShowMovieSection {...props} />;
      break;
    case 'content_crew':
      content = <ContentCrewSection {...props} />;
      break;

    default:
      break;
  }

  return content;
};

SectionManager.propTypes = {
  data: PropTypes.object.isRequired,
};

export default React.memo(SectionManager);
